export default "__VITE_ASSET__TabvTnX7__"